export const languages = [
  { label: "Arabic", value: "Arabic"},
  { label: "Armenian", value: "Armenian"},
  { label: "Cantonese", value: "Cantonese"},
  { label: "English", value: "English"},
  { label: "Farsi", value: "Farsi"},
  { label: "French", value: "French"},
  { label: "German", value: "German"},
  { label: "Hebrew", value: "Hebrew"},
  { label: "Hindi", value: "Hindi"},
  { label: "Korean", value: "Korean"},
  { label: "Mandarin", value: "Mandarin"},
  { label: "Russian", value: "Russian"},
  { label: "Spanish", value: "Spanish"},
  { label: "Tagalog (incl. Filipino)", value: "Tagalog"},
  { label: "Vietnamese", value: "Vietnamese"},
  { label: 'Not Listed', value: 'Not Listed' },
]
